import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import * as Yup from "yup";
import { useFormik } from "formik";
import Select from "react-select";
import Modal from "Common/Components/Modal";
import BreadCrumb from "Common/BreadCrumb";
import TableContainer from "Common/TableContainer";
import { Plus, SearchIcon, X } from "lucide-react";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import Swal from "sweetalert2";
import DeleteModal from "Common/DeleteModal";
import PaginationTest from "Common/Components/Paginationtest";
import DynamicSelect from "Common/Components/DynamicSelect";
import Pament2Column from "Common/Components/ColumnData/Pament2Column";
import FarmerInfoForModal from "Common/FarmerInfoForModal";
import FarmerIdentityInfo from "Common/Components/FarmerIdentityInfo";
import TableDropDownSmall from "pages/Components/TableDropDownSmall";
import BankPaymentModal, {
  BankFlowStage,
} from "Common/Components/BankPaymentModal";
import {
  BankPayment,
  WalletSettings,
  cancelBankPayment,
  clearPendingBankPayment,
  confirmBankPayment,
  getBankPaymentStatus,
  getSettlementAmount,
  getWalletSettings,
  loadPendingBankPayment,
  newIdempotencyKey,
  normalizeBankError,
  previewBankPayment,
  savePendingBankPayment,
  SettlementInfo,
} from "Common/utils/bankPayment";
const PaymentManagement = () => {
  const [payments, setPayments] = useState<any[]>([]);
  const [paymentTypes, setPaymentTypes] = useState<any[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setsize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [eventData, setEventData] = useState<any>();
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [reload, setreload] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [totalPages, setTotalPages] = useState<number>(0);
  const token = localStorage.getItem("app_atkey");
  const [dataListFarmer, setdataListFarmer] = useState<any>([]);
  const [searchvalueSelect, setsearchvalesearchvalueSelect] = useState<any>();
  const [FarmerID, setFarmerID] = useState<any>();
  const [searchValue, setsearchValue] = useState<any>();
  const cropYearID = localStorage.getItem("crop_year_id");
  const [sortName, setSortName] = useState<any>("");
  const [mainIDFarmer, setMainIDfarmer] = useState<any>(null);
  const [typepamentForSMS, settypepamentForSMS] = useState<any>(null);

  // ---- پرداخت بانکی ----
  const [walletSettings, setWalletSettings] = useState<WalletSettings | null>(
    null
  );
  const [walletLoading, setWalletLoading] = useState<boolean>(false);
  const [walletError, setWalletError] = useState<string>("");
  const [bankPayment, setBankPayment] = useState<BankPayment | null>(null);
  const [bankStage, setBankStage] = useState<BankFlowStage>("prepared");
  const [showBankModal, setShowBankModal] = useState<boolean>(false);
  const [isRefreshingStatus, setIsRefreshingStatus] = useState<boolean>(false);
  const attemptRef = useRef<{ signature: string; key: string } | null>(null);

  // ---- تسویه حساب ----
  const [settlement, setSettlement] = useState<SettlementInfo | null>(null);
  const [settlementLoading, setSettlementLoading] = useState<boolean>(false);
  const [settlementError, setSettlementError] = useState<string>("");
  const manualPriceRef = useRef<string>("");

  const bankEnabled = walletSettings?.bank_payments_enabled === true;
  const bankPhoneMissing = bankEnabled && !walletSettings?.phone_number;

  const parsePrice = (raw: string): number => {
    let cleaned = String(raw || "").replace(/,/g, "").trim();
    if (/^\d+-$/g.test(cleaned)) cleaned = "-" + cleaned.replace("-", "");
    cleaned = cleaned.replace(/-\s+/g, "-");
    const num = Number(cleaned);
    return isNaN(num) ? 0 : num;
  };

  const fetchWalletSettings = useCallback(async (): Promise<WalletSettings | null> => {
    setWalletLoading(true);
    setWalletError("");
    try {
      const data = await getWalletSettings();
      setWalletSettings(data);
      return data;
    } catch (error: any) {
      setWalletSettings(null);
      setWalletError(
        normalizeBankError(error).message ||
        "دریافت تنظیمات پرداخت انجام نشد. لطفاً دوباره تلاش کنید."
      );
      return null;
    } finally {
      setWalletLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchWalletSettings();
  }, [fetchWalletSettings]);

  // تنظیمات همان حساب با هر بار باز شدن فرم دوباره خوانده می‌شود
  const openPaymentModal = () => {
    fetchWalletSettings();
    setShowModal(true);
  };

  const [selectedFarmerInfo, setSelectedFarmerInfo] = useState<any>({
    amount_of_land: "",
    village_name: "",
    date_set: "",
  });
  const [sortState, setSortState] = useState<any>({
    name: null,
    order: "desc",
    step: 0,
  });
  useEffect(() => {
    const getFarmerInfo = async () => {
      try {
        setIsLoading(true);
        const res = await axios.get(
          `https://api.havirkesht.ir/commitment/${Number(mainIDFarmer)}`, // توجه: coomitID به commitID تغییر کرد
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
            },
          }
        );
        if (res?.data.amount_of_land) {
          setIsLoading(false);
          setSelectedFarmerInfo({
            amount_of_land: res?.data.amount_of_land || "", // اگر null بود، خالی برگردان
            village_name: res?.data?.village_name || "",
            date_set: res?.data?.date_set || "",
          });
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error fetching farmer info:", error);
      }
    };
    getFarmerInfo();
  }, [mainIDFarmer]);
  const sortLabels: any = {
    payment_reason_name: "نوع پرداخت",
    price: "مبلغ",
  };

  // دریافت انواع پرداخت‌ها
  useEffect(() => {
    const fetchPaymentTypes = async () => {
      try {
        const response = await axios.get(
          "https://api.havirkesht.ir/payment-reason/",
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setPaymentTypes(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت انواع پرداخت:", error);
        toast.error("خطا در بارگذاری انواع پرداخت");
      }
    };
    fetchPaymentTypes();
  }, [token]);
  const [YearCoptSelect, setYearCoptSelect] = useState<any>();
  useEffect(() => {
    const featchData = async () => {
      const response = await axios.get("https://api.havirkesht.ir/crop-year/");
      const getyear = response?.data?.items?.find(
        (items: any) => items.id == cropYearID
      );
      setYearCoptSelect(getyear?.crop_year_name);
    };
    featchData();
  }, []);
  // ✅ fetchPayments: تمیز و بدون پارامتر تکراری
  const fetchPayments = async (page: number, size: number) => {
    setIsLoading(true);
    try {
      const base = "https://api.havirkesht.ir/farmers_payment/";
      const params = new URLSearchParams();
      console.log(base, "base🤬🤬🤬");

      params.set("size", String(size));
      params.set("page", String(page));
      if (cropYearID != null) params.set("crop_year_id", String(cropYearID));

      // فقط یک سرچ: اولویت با searchValue.trim()، بعد searchQuery
      const term =
        (typeof searchValue === "string" && searchValue.trim()) ||
        (typeof searchQuery === "string" && searchQuery.trim()) ||
        "";
      if (term) params.set("search", term);

      // سورت هماهنگ با step
      if (sortState) {
        if (sortState.step === 2) {
          params.set("sort_by", "created_at");
          params.set("sort_order", "desc");
        } else {
          // step 0 یا 1
          const by = sortState.name || "updated_at";
          const order = sortState.order === "asc" ? "asc" : "desc";
          params.set("sort_by", by);
          params.set("sort_order", order);
        }
      }

      const url = `${base}?${params.toString()}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setPayments(response.data?.items);

      setTotalItems(response.data?.total || 0);
      setTotalPages(response?.data?.pages);
    } catch (error) {
      console.error("خطا در دریافت پرداخت‌ها:", error);
      toast.error("خطا در بارگذاری پرداخت‌ها");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        let url = `https://api.havirkesht.ir/commitment/?sort_by=updated_at&sort_order=desc&crop_year_id=${cropYearID}`;
        if (searchValue && searchValue.trim() !== "") {
          url += `&search=${encodeURIComponent(searchValue.trim())}`;
        }
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdataListFarmer(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };
    fetchData();
  }, [searchValue]);

  useEffect(() => {
    fetchPayments(currentPage, pageSize);
  }, [currentPage, pageSize, searchQuery, reload, sortState]);
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.id) {
      setEventData(cell.id);
    }
  };
  const handleDelete = async () => {
    if (eventData) {
      try {
        const res = await axios.delete(
          `https://api.havirkesht.ir/farmers_payment/${Number(eventData)}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
            },
          }
        );

        if (res.status === 200) {
          Swal.fire({
            title: "حذف  پرداختی",
            text: "عملیات حذف با موفقیت انجام شد",
            icon: "success",
          });
          setreload(!reload);
          setDeleteModal(false);
        } else {
          Swal.fire({
            title: "حذف  پرداختی",
            text: "مشکلی در حذف به وجود امده است",
            icon: "error",
          });
        }
        setEventData(null);
      } catch (error: any) {
        if (error?.response?.status === 409) {
          setDeleteModal(false);
          setEventData(null);
          return Swal.fire({
            title: "حذف پرداختی",
            text: "این پرداخت از طریق درگاه بانکی ثبت شده است و امکان تغییر یا حذف آن وجود ندارد.",
            icon: "warning",
          });
        }
        toast.error("مشکل در حذف داده ");
      }
    }
  };
  // فرم ثبت پرداخت جدید
  const formik = useFormik({
    initialValues: {
      price: "",
      payment_type: "",
      settle_balance: false,
    },
    validationSchema: Yup.object({
      price: Yup.string().when("settle_balance", {
        is: true,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.required("مبلغ الزامی است"),
      }),
      payment_type: Yup.string().required("نوع پرداخت الزامی است"),
      settle_balance: Yup.boolean(),
    }),
    onSubmit: async (values) => {
      if (!FarmerID) {
        setShowModal(false);
        return Swal.fire({
          title: "خطا در ثبت ",
          text: "لطفا کشاورز را جستوجو و انتخاب کنید",
          icon: "error",
        });
      }

      if (values.settle_balance && !settlement?.can_settle) {
        return Swal.fire({
          title: "تسویه حساب",
          text: "مانده قابل پرداخت برای تسویه وجود ندارد.",
          icon: "warning",
        });
      }

      // مسیر پرداخت بر اساس تنظیمات پیمانکار تعیین می‌شود
      if (!walletSettings) {
        await fetchWalletSettings();
        return Swal.fire({
          title: "تنظیمات پرداخت",
          text: "دریافت تنظیمات پرداخت انجام نشد. لطفاً دوباره تلاش کنید.",
          icon: "warning",
        });
      }

      if (bankEnabled) {
        if (bankPhoneMissing) {
          return Swal.fire({
            title: "شماره همراه پیمانکار",
            text: "برای پرداخت بانکی ابتدا باید شماره همراه پیمانکار در بخش داده‌های اولیه ثبت شود.",
            icon: "warning",
          });
        }
        await startBankPayment(values);
        return;
      }

      await submitLegacyPayment(values);
    },
  });
  // ---------- فرایند پرداخت بانکی ----------
  const lastPreviewBodyRef = useRef<any>(null);

  const currentSignature = () =>
    [
      FarmerID,
      cropYearID,
      formik.values.payment_type,
      formik.values.settle_balance ? "settle" : parsePrice(formik.values.price),
      formik.values.settle_balance,
    ].join("|");

  // مبلغ تسویه از پاسخ API گرفته می‌شود، نه از اعداد جدول صورتحساب
  async function loadSettlementAmount() {
    if (!FarmerID || !cropYearID) return;
    setSettlementLoading(true);
    setSettlementError("");
    try {
      const info = await getSettlementAmount(
        Number(FarmerID),
        Number(cropYearID)
      );
      setSettlement(info);
      if (info?.can_settle && info?.amount_rial) {
        formik.setFieldValue("price", String(info.amount_rial));
      } else {
        formik.setFieldValue("price", "");
        setSettlementError("مانده قابل پرداخت برای تسویه وجود ندارد.");
      }
    } catch (error: any) {
      setSettlement(null);
      formik.setFieldValue("price", "");
      setSettlementError(normalizeBankError(error).message);
    } finally {
      setSettlementLoading(false);
    }
  }

  const handleSettleToggle = async (checked: boolean) => {
    if (!checked) {
      formik.setFieldValue("settle_balance", false);
      setSettlement(null);
      setSettlementError("");
      formik.setFieldValue("price", manualPriceRef.current);
      return;
    }

    if (!FarmerID || !cropYearID) {
      return Swal.fire({
        title: "تسویه حساب",
        text: "ابتدا کشاورز و سال زراعی را انتخاب کنید.",
        icon: "warning",
      });
    }

    manualPriceRef.current = formik.values.price;
    formik.setFieldValue("settle_balance", true);
    await loadSettlementAmount();
  };

  // با تغییر کشاورز یا سال زراعی، مبلغ تسویه قبلی حذف و دوباره دریافت می‌شود
  useEffect(() => {
    if (!formik.values.settle_balance) return;
    formik.setFieldValue("price", "");
    setSettlement(null);
    setSettlementError("");
    loadSettlementAmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FarmerID, cropYearID]);

  const notifyFarmerBySms = async (paymentId?: number | null) => {
    const typesAllow = [
      "پرداخت بابت بار",
      "مساعده قبل از برداشت",
      "پرداخت بابت تسویه نهایی",
    ];
    if (!paymentId || !typesAllow.includes(typepamentForSMS)) return;
    try {
      await axios.post(
        `https://api.havirkesht.ir/sms/farmer-payment-notification/${paymentId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (error) {
      console.error("خطا در ارسال پیامک اطلاع‌رسانی:", error);
    }
  };

  const resetPaymentForm = () => {
    settypepamentForSMS(null);
    formik.resetForm();
    setFarmerID(null);
    setsearchvalesearchvalueSelect("");
    setsearchValue("");
    setMainIDfarmer(null);
    setShowModal(false);
    attemptRef.current = null;
    lastPreviewBodyRef.current = null;
    setSettlement(null);
    setSettlementError("");
    manualPriceRef.current = "";
  };

  const isNonFinal = (payment: BankPayment | null) =>
    !!payment &&
    (payment.status === "processing" ||
      payment.status === "unknown" ||
      payment.requires_reconciliation === true);

  function storeOrClearPending(payment: BankPayment) {
    const body = lastPreviewBodyRef.current;
    if (isNonFinal(payment) && body) {
      savePendingBankPayment({
        id: payment.id,
        idempotency_key: body.idempotency_key,
        farmer_id: body.farmer_id,
        crop_year_id: body.crop_year_id,
        payment_type: body.payment_type,
        price: body.price,
        settle_balance: body.settle_balance,
        amount_rial: payment.amount_rial,
        recipient_name: payment.recipient_name,
        status: payment.status,
      });
    } else if (!isNonFinal(payment)) {
      clearPendingBankPayment();
    }
  }

  async function finalizeBankResult(payment: BankPayment) {
    setBankPayment(payment);
    setBankStage("result");
    storeOrClearPending(payment);

    if (payment.status === "succeeded") {
      await notifyFarmerBySms(payment.payment_id);
      resetPaymentForm();
      fetchPayments(currentPage, selectedNumber);
    }
  }

  // مسیر قبلی ثبت پرداخت، بدون اتصال به بانک
  async function submitLegacyPayment(values: any) {
    setIsLoading(true);
    try {
      const payload: any = {
        farmer_id: Number(FarmerID),
        crop_year_id: Number(cropYearID),
        payment_type: values.payment_type,
        settle_balance: !!values.settle_balance,
      };
      // در حالت تسویه، مبلغ توسط سرور تعیین می‌شود
      if (!values.settle_balance) payload.price = parsePrice(values.price);

      const response = await axios.post(
        "https://api.havirkesht.ir/farmers_payment/",
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setShowModal(false);
      await notifyFarmerBySms(Number(response?.data?.id));
      resetPaymentForm();
      Swal.fire({
        title: "عملیات پرداختی",
        text: "پرداخت ثبت شد",
        icon: "success",
      });
      fetchPayments(currentPage, selectedNumber);
    } catch (error: any) {
      const normalized = normalizeBankError(error);
      const httpStatus = error?.response?.status;

      // پیمانکار به حالت بانکی تغییر کرده است: تنظیمات دوباره خوانده و از مسیر بانکی ادامه داده می‌شود
      if (
        httpStatus === 409 &&
        normalized.code === "bank_confirmation_required"
      ) {
        const settings = await fetchWalletSettings();
        if (!settings?.phone_number) {
          return Swal.fire({
            title: "شماره همراه پیمانکار",
            text: "برای پرداخت بانکی ابتدا باید شماره همراه پیمانکار در بخش داده‌های اولیه ثبت شود.",
            icon: "warning",
          });
        }
        await startBankPayment(values);
        return;
      }

      if (httpStatus === 400) {
        return Swal.fire(
          "خطا ",
          "کشاورز با سال  زراعی انتخاب شده پیدا نشده",
          "error"
        );
      }

      setMainIDfarmer(null);
      Swal.fire({
        title: "عملیات پرداختی",
        text: normalized.message,
        icon: "error",
      });
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  async function startBankPayment(values: any) {
    const signature = currentSignature();

    // پیش‌نمایش قبلی که به اطلاعات فعلی فرم مربوط نیست، لغو می‌شود
    if (bankPayment?.status === "prepared") {
      try {
        await cancelBankPayment(bankPayment.id);
      } catch (error) {
        console.error("خطا در لغو پیش‌نمایش قبلی:", error);
      }
      setBankPayment(null);
    }

    // برای تکرار همان پرداخت، شناسه idempotency تازه ساخته نمی‌شود
    if (!attemptRef.current || attemptRef.current.signature !== signature) {
      attemptRef.current = { signature, key: newIdempotencyKey() };
    }

    const body: any = {
      idempotency_key: attemptRef.current.key,
      farmer_id: Number(FarmerID),
      crop_year_id: Number(cropYearID),
      payment_type: values.payment_type,
      settle_balance: !!values.settle_balance,
    };
    // در حالت تسویه، مبلغ نهایی همان amount_rial پاسخ پیش‌نمایش است
    if (!values.settle_balance) body.price = parsePrice(values.price);
    lastPreviewBodyRef.current = body;

    setIsLoading(true);
    try {
      const preview = await previewBankPayment(body);

      if (preview?.status === "prepared") {
        setBankPayment(preview);
        setBankStage("prepared");
        setShowBankModal(true);
      } else {
        // پاسخ تکراری با وضعیتی غیر از prepared: پنجره تأیید باز نمی‌شود
        setShowBankModal(true);
        await finalizeBankResult(preview);
      }
    } catch (error: any) {
      const normalized = normalizeBankError(error);
      if (normalized.payment && normalized.payment.status !== "prepared") {
        setShowBankModal(true);
        await finalizeBankResult(normalized.payment);
      } else {
        Swal.fire({
          title: "پرداخت بانکی",
          text: normalized.message,
          icon: normalized.isNetworkError ? "warning" : "error",
        });
      }
    } finally {
      setIsLoading(false);
    }
  }

  async function handleBankConfirm() {
    if (!bankPayment) return;
    setBankStage("confirming");
    try {
      const result = await confirmBankPayment(bankPayment.id);
      await finalizeBankResult({
        ...result,
        id: result?.id ?? bankPayment.id,
      });
    } catch (error: any) {
      const normalized = normalizeBankError(error);

      if (normalized.payment) {
        await finalizeBankResult({
          ...normalized.payment,
          id: normalized.payment.id ?? bankPayment.id,
        });
        return;
      }

      // قطع ارتباط، خطای سرور یا خطای ذخیره‌سازی: نتیجه از وضعیت خود پرداخت خوانده می‌شود
      const unclear =
        normalized.isNetworkError ||
        normalized.code === "payment_storage_error" ||
        (normalized.httpStatus ?? 0) >= 500;

      if (unclear || normalized.isAuthError) {
        await refreshBankStatus(bankPayment.id, true);
        if (normalized.isAuthError) {
          toast.error(normalized.message);
        }
        return;
      }

      setShowBankModal(false);
      setBankPayment(null);
      attemptRef.current = null;

      // تغییر مانده تسویه یا اطلاعات کیف پول: مبلغ تازه گرفته و تأیید دوباره لازم است
      const dataChanged =
        normalized.code === "settle_balance_changed" ||
        normalized.code === "wallet_changed";
      if (dataChanged) {
        setShowModal(true);
        if (formik.values.settle_balance) await loadSettlementAmount();
      }

      Swal.fire({
        title: "پرداخت بانکی",
        text: normalized.message,
        icon: dataChanged ? "warning" : "error",
      });
    }
  }

  async function refreshBankStatus(
    id: number | string,
    fallbackToUnknown = false
  ) {
    setIsRefreshingStatus(true);
    try {
      const fresh = await getBankPaymentStatus(id);
      await finalizeBankResult({ ...fresh, id: fresh?.id ?? id });
    } catch (error: any) {
      if (fallbackToUnknown) {
        await finalizeBankResult({
          ...(bankPayment as BankPayment),
          id,
          status: "unknown",
          requires_reconciliation: true,
          message:
            "نتیجه پرداخت هنوز مشخص نیست. تا تعیین وضعیت، پرداخت را دوباره ثبت نکنید.",
        });
      } else {
        toast.error(normalizeBankError(error).message);
      }
    } finally {
      setIsRefreshingStatus(false);
    }
  }

  async function handleBankReject() {
    if (!bankPayment) return;
    setBankStage("cancelling");
    try {
      const result = await cancelBankPayment(bankPayment.id);
      if (result?.status === "cancelled") {
        clearPendingBankPayment();
        setShowBankModal(false);
        setBankPayment(null);
        attemptRef.current = null;
        return;
      }
      await finalizeBankResult({ ...result, id: result?.id ?? bankPayment.id });
    } catch (error: any) {
      const normalized = normalizeBankError(error);
      if (normalized.payment) {
        await finalizeBankResult({
          ...normalized.payment,
          id: normalized.payment.id ?? bankPayment.id,
        });
        return;
      }
      // نتیجه لغو مشخص نیست: ابتدا وضعیت همان شناسه دریافت شود
      await refreshBankStatus(bankPayment.id);
      toast.error(normalized.message);
    }
  }

  const handleCloseBankModal = async () => {
    if (bankStage === "prepared" && bankPayment?.status === "prepared") {
      await handleBankReject();
      return;
    }
    setShowBankModal(false);
    if (!isNonFinal(bankPayment)) {
      setBankPayment(null);
    }
  };

  const handleRestartPreview = async () => {
    setShowBankModal(false);
    setBankPayment(null);
    attemptRef.current = null;
    openPaymentModal();
  };

  // پیگیری خودکار وضعیت در حالت «در حال بررسی»
  useEffect(() => {
    if (!showBankModal || bankStage !== "result") return;
    if (bankPayment?.status !== "processing") return;
    const id = bankPayment.id;
    const timer = setInterval(() => {
      getBankPaymentStatus(id)
        .then((fresh) => finalizeBankResult({ ...fresh, id: fresh?.id ?? id }))
        .catch(() => undefined);
    }, 5000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showBankModal, bankStage, bankPayment?.status, bankPayment?.id]);

  // بازیابی پرداخت در جریان پس از تازه‌سازی صفحه
  useEffect(() => {
    const pending = loadPendingBankPayment();
    if (!pending) return;
    lastPreviewBodyRef.current = {
      idempotency_key: pending.idempotency_key,
      farmer_id: pending.farmer_id,
      crop_year_id: pending.crop_year_id,
      payment_type: pending.payment_type,
      price: pending.price,
      settle_balance: pending.settle_balance,
    };
    getBankPaymentStatus(pending.id)
      .then((fresh) => {
        const payment = { ...fresh, id: fresh?.id ?? pending.id };
        if (!isNonFinal(payment)) {
          clearPendingBankPayment();
          return;
        }
        setBankPayment(payment);
        setBankStage("result");
        setShowBankModal(true);
      })
      .catch(() => undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // تغییر اطلاعات فرم پیش از تأیید، پیش‌نمایش قبلی را باطل می‌کند
  useEffect(() => {
    if (!bankPayment || bankPayment.status !== "prepared") return;
    if (attemptRef.current?.signature === currentSignature()) return;
    const staleId = bankPayment.id;
    setBankPayment(null);
    setShowBankModal(false);
    cancelBankPayment(staleId).catch(() => undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    FarmerID,
    cropYearID,
    formik.values.payment_type,
    formik.values.price,
    formik.values.settle_balance,
  ]);

  const displaySortLabel = sortName ? sortLabels[sortName] || sortName : "";

  const handleSelect = (value: number) => {
    setSelectedNumber(value);
    const newSize = value;
    let newPage = currentPage;

    // استفاده از totalItems به جای payments
    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize));
    }

    setsize(newSize);
    setCurrentPage(newPage);

    // فراخوانی داده‌ها با سایز و صفحه تنظیم‌شده
    fetchPayments(newPage, newSize);
  };

  // ✅ columnName: چرخه‌ی 0(نزولی) → 1(صعودی) → 2(created_at desc)
  const columnName = (name: string) => {
    setSortState((prev: any) => {
      if (prev?.name === name) {
        const nextStep = ((prev.step ?? 0) + 1) % 3;
        if (nextStep === 0) {
          return { name, order: "desc", step: 0 }; // نزولی روی همین ستون
        }
        if (nextStep === 1) {
          return { name, order: "asc", step: 1 }; // صعودی روی همین ستون
        }
        return { name, order: "desc", step: 2 }; // حالت پیش‌فرض: created_at desc (در fetch اعمال می‌کنیم)
      } else {
        // ستون جدید: از نزولی شروع کن
        return { name, order: "desc", step: 0 };
      }
    });

    setreload((r: boolean) => !r);
  };

  const resetSorting = () => {
    setSortState({
      name: null,
      order: "desc",
      step: 0,
    });
    setreload(!reload);
  };
  const columns = Pament2Column({ onClickDelete, columnName });
  const formatNumber = (num: number | string) => {
    if (num === null || num === undefined || num === "") return "";
    const numStr = num.toString().replace(/,/g, "");
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  // const parseFormattedNumber = (formattedNum: string) => {
  //   if (formattedNum === "-") return "-"; // اجازه تایپ منفی

  //   const cleaned = formattedNum.replace(/,/g, "").replace(/[^\d-]/g, "");

  //   return Number(cleaned);
  // };



  return (
    <React.Fragment>
      <BreadCrumb pageTitle="مدیریت پرداخت‌ها" title="پنل مدیریت" />
      <ToastContainer rtl={true} />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <div className="card" id="paymentTable">
        <div className="card-body">
          <div className="flex flex-col md:flex-row gap-3 mb-4 items-center">
            <h6 className="text-15 grow">
              تعداد پرداخت‌ها: <b>{totalItems}</b>
              <label className="flex flex-col gap-2 mt-4 sm:flex-row sm:items-center">
                <span className="whitespace-nowrap p-1">جستجو:</span>
                <div className="relative w-full sm:w-64">
                  <input
                    type="text"
                    className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                    placeholder="جستجو..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <SearchIcon
                    size={15}
                    className="absolute inset-y-0 top-2 left-2 flex items-center text-gray-400"
                  />
                </div>
              </label>
            </h6>
            <div className="w-full sm:w-auto">
              <TableDropDownSmall onSelect={handleSelect} />
            </div>
            <div className="shrink-0">
              <button
                onClick={openPaymentModal}
                className="text-white btn bg-blue-500 border-blue-500 hover:text-white hover:bg-blue-600"
              >
                <span className="align-middle">ثبت پرداخت جدید</span>
                <Plus className="inline-block size-4" />
              </button>
            </div>
          </div>
          {sortName ? (
            <div className="gap-1 mb-2 items-center flex">
              <X
                size={16}
                className="text-red-600 cursor-pointer"
                onClick={() => setSortName(null)}
              />
              مرتب‌سازی بر اساس: {displaySortLabel}
            </div>
          ) : (
            ""
          )}
          {sortState.name && (
            <div className="gap-1 mb-2 items-center flex">
              <X
                size={16}
                className="text-red-600 cursor-pointer"
                onClick={resetSorting}
              />
              مرتب‌سازی بر اساس:{" "}
              {sortState.step === 2
                ? ` (تاریخ ایجاد)`
                : `${sortLabels[sortState.name]} ${sortState.order === "asc" ? "(صعودی)" : "(نزولی)"
                }`}
            </div>
          )}

          {payments.length > 0 ? (
            <TableContainer
              isPagination={false}
              columns={columns}
              isGlobalFilter={false}
              data={payments}
              customnumberfortable={12}
              customPageSize={selectedNumber}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={isLoading ? 10 : 0}
              text={isLoading ? "در حال بارگذاری..." : "پرداختی یافت نشد"}
            />
          )}
        </div>
      </div>
      <div className="mb-2">
        <PaginationTest
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      </div>
      {/* مودال ثبت پرداخت جدید */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="fixed inset-0 flex items-center justify-center z-[9999]  bg-opacity-gray-50 backdrop-blur-sm"
        dialogClassName="relative w-full max-w-md bg-white dark:bg-zink-600 rounded-lg shadow-xl mx-4 my-8"
      >
        <Modal.Header className="flex items-center justify-between p-4 border-b dark:border-zink-500">
          <Modal.Title className="text-xl font-semibold">
            ثبت پرداخت جدید
          </Modal.Title>
          <button
            onClick={() => setShowModal(false)}
            className="text-gray-400 hover:text-gray-500 transition-colors"
          ></button>
        </Modal.Header>

        <Modal.Body className="p-6 overflow-y-auto max-h-[70vh]">
          <form onSubmit={formik.handleSubmit}>
            <div className="flex mb-3 flex-col gap-2">
              <label
                htmlFor="farmer"
                className="text-base font-medium dark:text-white"
              >
                نام کشاورز:
              </label>
              <DynamicSelect
                FarmerID={FarmerID}
                dataListFarmer={dataListFarmer}
                onChange={setFarmerID}
                setMainIDfarmer={setMainIDfarmer}
                onInputChange={setsearchValue}
                inputValue={searchValue}
              />
              {mainIDFarmer && (
                <div className="mt-3">
                  {isLoading ? (
                    <span className="bg-green-200 dark:bg-zink-600 p-2 rounded-md text-xs text-gray-500 ">
                      {" "}
                      در حال دریافت داده ...
                    </span>
                  ) : (
                    <FarmerInfoForModal
                      selectedFarmerInfo={selectedFarmerInfo}
                    />
                  )}
                </div>
              )}
              <FarmerIdentityInfo farmerId={FarmerID} cropYearId={cropYearID} />
            </div>
            <div className="space-y-4">
              <div>
                <label className="block mb-2 text-right font-medium">
                  نوع پرداخت
                </label>
                <Select
                  value={
                    formik.values.payment_type
                      ? {
                        value: formik.values.payment_type,
                        label:
                          paymentTypes.find(
                            (t: any) => t.id === formik.values.payment_type
                          )?.reason_name || "",
                      }
                      : null
                  }
                  options={paymentTypes.map((type) => ({
                    value: type.id,
                    typepamentSMS: type.reason_name,
                    label: type.reason_name,
                  }))}
                  onChange={(selected: any) => {
                    formik.setFieldValue("payment_type", selected?.value);
                    settypepamentForSMS(selected?.typepamentSMS);
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      padding: "8px",
                      borderRadius: "8px",
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  menuPortalTarget={document.body}
                  onBlur={() => formik.setFieldTouched("payment_type", true)}
                  placeholder="انتخاب کنید"
                />
                {formik.touched.payment_type && formik.errors.payment_type && (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.payment_type}
                  </div>
                )}
              </div>
              <div>
                <label className="block mb-2 text-right font-medium">
                  مبلغ پرداخت <span className="text-blue-600">(ریال)</span>
                </label>
                <input
                  type="text"
                  name="price"
                  value={formatNumber(formik.values.price)}
                  onChange={(e) => {
                    formik.setFieldValue("price", e.target.value);
                  }}
                  onBlur={formik.handleBlur}
                  readOnly={formik.values.settle_balance}
                  style={{ direction: "rtl" }}
                  className="w-full p-3 rtl border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 read-only:bg-slate-100 dark:read-only:bg-zink-500"
                  placeholder={
                    formik.values.settle_balance
                      ? "مبلغ تسویه از سرور دریافت می‌شود"
                      : "مبلغ را وارد کنید"
                  }
                />

                {formik.touched.price && formik.errors.price && (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.price}
                  </div>
                )}

                <label className="flex items-center gap-2 mt-3 cursor-pointer select-none">
                  <input
                    type="checkbox"
                    checked={formik.values.settle_balance}
                    onChange={(e) => handleSettleToggle(e.target.checked)}
                    className="size-4 accent-blue-600"
                  />
                  <span className="font-medium">تسویه حساب</span>
                </label>

                {formik.values.settle_balance && (
                  <div className="mt-2 p-3 text-sm rounded-md bg-slate-100 dark:bg-zink-500 dark:text-white flex flex-col gap-1">
                    {settlementLoading ? (
                      <span>در حال دریافت مبلغ تسویه...</span>
                    ) : (
                      <>
                        {settlement?.remaining_balance_rial != null && (
                          <span>
                            مانده طلب/بدهی:{" "}
                            <b>
                              {formatNumber(settlement.remaining_balance_rial)}{" "}
                              ریال
                            </b>
                          </span>
                        )}
                        {settlementError && (
                          <span className="text-red-500">
                            {settlementError}
                          </span>
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>

              <div className="">
                سال زراعی انتخاب شده:{" "}
                <span className="text-custom-600 dark:text-gray-200 bold">
                  {YearCoptSelect ? YearCoptSelect : ""}{" "}
                </span>
              </div>
            </div>

            {walletError && (
              <div className="mt-4 p-3 text-sm rounded-md bg-red-50 text-red-600 dark:bg-zink-500 flex flex-col gap-2">
                <span>{walletError}</span>
                <button
                  type="button"
                  onClick={fetchWalletSettings}
                  className="self-start px-3 py-1 text-white bg-red-500 rounded hover:bg-red-600"
                >
                  تلاش دوباره
                </button>
              </div>
            )}

            {bankPhoneMissing && (
              <div className="mt-4 p-3 text-sm rounded-md bg-amber-50 text-amber-700 dark:bg-zink-500 dark:text-amber-300">
                برای پرداخت بانکی، ابتدا باید «شماره همراه پیمانکار» در بخش
                داده‌های اولیه ثبت شود.
              </div>
            )}

            <div className="mt-8 flex justify-center">
              <button
                type="submit"
                className="px-8 py-3 text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50"
                disabled={
                  isLoading ||
                  walletLoading ||
                  !!walletError ||
                  bankPhoneMissing ||
                  settlementLoading ||
                  (formik.values.settle_balance && !settlement?.can_settle)
                }
              >
                {isLoading ? "در حال ثبت..." : "ثبت پرداخت"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <BankPaymentModal
        show={showBankModal}
        payment={bankPayment}
        stage={bankStage}
        isRefreshing={isRefreshingStatus}
        onConfirm={handleBankConfirm}
        onReject={handleBankReject}
        onClose={handleCloseBankModal}
        onRefreshStatus={() =>
          bankPayment && refreshBankStatus(bankPayment.id)
        }
        onRestartPreview={handleRestartPreview}
      />
    </React.Fragment>
  );
};

export default PaymentManagement;
